<template>
  <div class="arrow-box flex flex-ali-center flex-center" :style="style">
    <div class="arrow-bottom" :style="arrowStyle"></div>
    <div class="center">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    height: {
      default: 30
    },
    width: {
      type: Number,
      default: 2
    },
    gap: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      
    };
  },
  computed:{
    style(){
      return {
        height: isNaN(this.height) ? this.height : `${this.height}px`,
        margin: `${this.gap}px 0 ${this.gap + 10}px 0`
      }
    },
    arrowStyle(){
      return {
        width: `${this.width}px`
      }
    }
  },
  mounted(){
  },
  methods:{
    
  }
};
</script>
<style lang="less" scoped>
@arrow-height: 10px;
@arrow-width: 3px;
@arrow-color: #cfcfcf;
.arrow-box{
  position: relative;
  .arrow-bottom {
    height: 100%;
    background-color: @arrow-color;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      bottom: -@arrow-height;
      left: 50%;
      transform: translateX(-50%);
      border-left: @arrow-width solid transparent;
      border-right: @arrow-width solid transparent;
      border-top: @arrow-height solid #cfcfcf;
    }
  }
  .center{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }
}
</style>
